import { CalendarCheck, Music, Share2 } from "lucide-react";

export default function MobileBar() {
  return (
    <nav
      data-testid="mobile-bottom-bar"
      aria-label="Quick actions"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden px-4 pb-4"
    >
      <div className="glass rounded-2xl flex overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.6)]">
        <a
          href="#booking"
          data-testid="mobilebar-book"
          className="flex-1 flex items-center justify-center gap-2 bg-volt text-ink font-head font-extrabold uppercase tracking-wider text-sm py-4"
        >
          <CalendarCheck className="w-4 h-4" /> Book
        </a>
        <a
          href="#music"
          data-testid="mobilebar-music"
          className="flex-1 flex items-center justify-center gap-2 text-zinc-300 font-head font-bold uppercase tracking-wider text-sm py-4 hover:text-volt transition-colors"
        >
          <Music className="w-4 h-4" /> Music
        </a>
        <a
          href="#socials"
          data-testid="mobilebar-social"
          className="flex-1 flex items-center justify-center gap-2 text-zinc-300 font-head font-bold uppercase tracking-wider text-sm py-4 hover:text-volt transition-colors"
        >
          <Share2 className="w-4 h-4" /> Social
        </a>
      </div>
    </nav>
  );
}
